import { zodResolver } from "@mantine/form";
import { inventoryItemSupplierDataSchema } from "beitary-shared";
import { z } from "zod";

const supplierFormSchema = inventoryItemSupplierDataSchema;

export type SupplierFormValues = z.infer<typeof supplierFormSchema>;

export const rules = zodResolver(supplierFormSchema);
